import type { StoredCard } from "@/types";

export const PAYMENT_METHOD_TYPE = {
  APPLE: "APPLE",
  STORED_CARD: "STORED_CARD",
} as const;

export type PaymentMethodType =
  (typeof PAYMENT_METHOD_TYPE)[keyof typeof PAYMENT_METHOD_TYPE];

/** Value alias — allows enum-style `PaymentMethodType.APPLE` access at runtime. */
export const PaymentMethodType = PAYMENT_METHOD_TYPE;

export interface PaymentMethodOption {
  paymentMethodType: PaymentMethodType;
  card?: StoredCard;
}

export const PROCESSING = {
  NONE: "NONE",
  TOKENIZATION: "TOKENIZATION",
  SUBMIT: "SUBMIT",
} as const;

export type Processing = (typeof PROCESSING)[keyof typeof PROCESSING];

/** Value alias — allows enum-style `Processing.NONE` access at runtime. */
export const Processing = PROCESSING;

export interface PaymentSubmissionOptions {
  termsAccepted?: boolean;
  documentsSigned?: boolean;
  shouldUseWalletBalance?: boolean;
}

export const PAGE_ERROR = {
  NONE: "NONE",
  TOKENIZATION_FAILED: "TOKENIZATION_FAILED",
} as const;

export type PageError = (typeof PAGE_ERROR)[keyof typeof PAGE_ERROR];

/** Value alias — allows enum-style `PageError.NONE` access at runtime. */
export const PageError = PAGE_ERROR;

export interface CardFormState {
  cardNumber: string;
  expiryDate: string;
  cvv: string;
  cardholderName: string;
  saveCard: boolean;
}
